module.exports = "table{width:100%}.encabezadotable{text-align:center}\n"